import React, { useEffect, useState } from 'react';
import Breadcrumbs from '../../components/BreadCrumbs';
import TabView from '../../components/TabView';
import DashboardMainView from './DashboardMainView';
import MapDashboardView from './MapDashboardView';
import StatsDashboardView from './StatsDashboardView';

function Dashboard() {
    const [activeTab, setActiveTab] = useState("Stats");


    const handleTabChange = (value) => {
        setActiveTab(value);
    };

    useEffect(() => {
        handleTabChange("Stats");
    }, []);

    return (<>
        <Breadcrumbs items={[
            { name: 'Home' },
            { name: activeTab },
        ]} />
        <TabView
            onChanged={handleTabChange}
            isCenterAligned={false}
            tabs={[
                {
                    key: 'Stats',
                    title: 'Stats',
                    content: (
                        <StatsDashboardView />
                    ),
                },
                // {
                //     key: 'Map',
                //     title: 'Map',
                //     content: (
                //         <MapDashboardView />
                //     ),
                // },
                // {
                //     key: 'Summary',
                //     title: 'Summary',
                //     content: (
                //         <DashboardMainView />
                //     ),
                // },
            ]} />
    </>);
}

export default Dashboard;